import {GET_EMPLOYEES_PENDING_APPLICATIONS} from "../../enums/Employees/employees.types";

export const getEmployeesPendingApplicationsAction = (requests) => {
    return {
        type: GET_EMPLOYEES_PENDING_APPLICATIONS,
        payload: requests,
    };
};